<template>
  <div class="p-2" style="border: solid 1px #eeeeee">
    <b-form-input id="accountPicker" size="sm" type="text" v-model="searchedTag" placeholder="Enter name" @input="onChange" autocomplete="off"/>
    <div class="d-flex flex-wrap mt-2">
      <div class="tag-object d-flex p-1 px-2 m-1" v-for="returnedTag in returnedTags" :key="returnedTag.id">
        <span class="pr-2" >
          {{ returnedTag.name }} <span style="font-weight: 300;">({{ tagTypes[returnedTag.type] }})</span>
        </span>
        <div class="pl-2" style="border-left: solid 2px #FFFFFF">
          <span class="add-tag" @click="addTag(returnedTag)">
            <i class="fas fa-plus" style="cursor: pointer;" ></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startupResourcesAPI from '../../api/startupResources'

export default {
  name: '',
  props: ['resource'],
  data: function () {
    return {
      adderToggled: false,
      searchedTag: '',
      returnedTags: [],
      isTyping: false,
      tagTypes: {
        investor_tag: 'Resource Type',
        investor_target_area: 'Resource Target Area/Type',
        investor_target_size: 'Resource Target Size/Type'
      }
    }
  },
  methods: {
    resetSearchedTag () {
      this.searchedTag = ''
      this.returnedTags = []
    },
    onChange () {
      setTimeout(() => {
        this.isTyping = false
        if (this.searchedTag.length > 1) {
          startupResourcesAPI.searchTags(this.resource.id, this.searchedTag).then(
            response => {
              this.returnedTags = response.data.data
            }
          )
        } else {
          this.returnedTags = []
        }
      }, 500)
      this.isTyping = true
    },
    addTag (tagObject) {
      startupResourcesAPI.addTagToResource(this.resource.id, tagObject.id).then(
        response => {
          if (response.data.success) {
            this.$emit('tagAdded', tagObject)
          }
          console.log(response)
        }
      )
    }
  },
  created () {
    this.resetSearchedTag()
  }
}
</script>

<style scoped>
.tag-object {
  background: #26A65B;
  color: #FFFFFF;
  font-size: 0.9em;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/startupResources/ResourceTagAdder.vue